import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PREFERRED_PRICE_DISPLAY from '../constants/preferredPriceDisplay';
import Select from 'react-select';
import utils from '../../utils/utils';

const DEFAULT_FEE_MULTIPLIER = 1.35;

class PriceFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.props.formData
      ? {
          showUnitPrice: !!this.props.formData.unitPrice,
          ...this.props.formData,
        }
      : {
          showUnitPrice: false,
          wholesalePrice: '',
          price: '',
          unitPrice: '',
          groupPrice: '',
          comparedToPrice: '',
          standardUnitQuantity: '',
          preferredPriceDisplay: PREFERRED_PRICE_DISPLAY.price,
        };

    this.onWholesalePriceChange = this.onWholesalePriceChange.bind(this);
    this.onWholesaleUnitPriceChange = this.onWholesaleUnitPriceChange.bind(this);
    this.onPriceChange = this.onPriceChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showUnitPrice: !!nextProps.formData.unitPrice,
      ...nextProps.formData,
    });
  }

  onChange(name) {
    return (event) => {
      this.setState(
        {
          [name]: event.target.value,
        },
        () => this.props.onChange(this.state)
      );
    };
  }

  onWholesalePriceChange(event) {
    const feeMultiplier =
      this.props.schema.feePercentage || this.props.schema.feePercentage === 0
        ? (100 + this.props.schema.feePercentage) / 100
        : DEFAULT_FEE_MULTIPLIER;

    const vatMultiplier = this.props.schema.vatPercentage ? (100 + this.props.schema.vatPercentage) / 100 : 1;

    const newPrice = !isNaN(event.target.value)
      ? utils.getRoundedPrice(event.target.value * feeMultiplier * vatMultiplier)
      : 0;

    this.setState(
      {
        wholesalePrice: event.target.value,
        price: newPrice,
      },
      () => this.props.onChange(this.state)
    );
  }

  onPriceChange(event) {
    const feeMultiplier =
      this.props.schema.feePercentage || this.props.schema.feePercentage === 0
        ? (100 + this.props.schema.feePercentage) / 100
        : DEFAULT_FEE_MULTIPLIER;

    const vatMultiplier = this.props.schema.vatPercentage ? (100 + this.props.schema.vatPercentage) / 100 : 1;

    const newPrice = !isNaN(event.target.value)
      ? utils.getRoundedPrice(event.target.value / feeMultiplier / vatMultiplier, 10000)
      : 0;

    this.setState(
      {
        price: event.target.value,
        wholesalePrice: `${newPrice}`,
      },
      () => this.props.onChange(this.state)
    );
  }

  onWholesaleUnitPriceChange(event) {
    const feeMultiplier = this.props.schema.feePercentage
      ? (100 + this.props.schema.feePercentage) / 100
      : DEFAULT_FEE_MULTIPLIER;
    const vatMultiplier = this.props.schema.vatPercentage ? (100 + this.props.schema.vatPercentage) / 100 : 1;

    const newPrice = !isNaN(event.target.value)
      ? utils.getRoundedPrice(event.target.value * feeMultiplier * vatMultiplier)
      : 0;

    this.setState(
      {
        wholesaleUnitPrice: event.target.value,
        unitPrice: newPrice,
      },
      () => this.props.onChange(this.state)
    );
  }

  onPreferredPriceDisplayChange(newValue) {
    this.setState(
      {
        preferredPriceDisplay: newValue,
      },
      () => this.props.onChange(this.state)
    );
  }

  render() {
    const preferredPriceDisplayOptions = Object.keys(PREFERRED_PRICE_DISPLAY).map((key) => {
      const value = PREFERRED_PRICE_DISPLAY[key];
      return {
        value,
        label: this.props.intl.formatMessage({ id: 'form.field.preferred.price.display.value.' + value }),
      };
    });

    const selectedPreferredPriceDisplayValue = preferredPriceDisplayOptions.find(
      (option) => option.value === this.state.preferredPriceDisplay
    );

    return (
      <>
        {this.props.schema.hideLegend ? (
          ''
        ) : (
          <legend>
            <FormattedMessage id={this.props.schema.legend || 'form.price.fields.legend'} />
          </legend>
        )}

        <div className="row">
          <div className="col-12 col-sm-6">
            <div className="form-group field field-string">
              <label className="control-label">
                <FormattedMessage id={'form.field.wholesale.price.label'} />
              </label>
              <div className="m-b-1">
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={this.state.wholesalePrice}
                  onChange={this.onWholesalePriceChange}
                />
              </div>
              <p className="help-block">
                <FormattedMessage
                  id={
                    this.state.showUnitPrice
                      ? 'form.field.wholesale.price.with.unit.help'
                      : 'form.field.wholesale.price.help'
                  }
                />
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="form-group field field-string">
              <label className="control-label">
                <FormattedMessage id={'form.field.price.label'} />
              </label>
              <div className="m-b-1">
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={this.state.price}
                  onChange={this.onPriceChange}
                />
              </div>
              <p className="help-block">
                <FormattedMessage id={'form.field.price.help'} />
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="form-group field field-string">
              <label className="control-label">
                <FormattedMessage id={'form.field.compared.to.price.label'} />
              </label>
              <div className="m-b-1">
                <input
                  className="form-control"
                  placeholder=""
                  type="text"
                  value={this.state.comparedToPrice}
                  onChange={this.onChange('comparedToPrice')}
                />
              </div>
              <p className="help-block">
                <FormattedMessage id="form.field.compared.to.price.help" />
              </p>
            </div>
          </div>
          {this.props.schema.showGroupPrice ? (
            <div className="col-12 col-sm-6">
              <div className="form-group field field-string">
                <label className="control-label">
                  <FormattedMessage id={'form.field.group.price.label'} />
                </label>
                <div className="m-b-1">
                  <input
                    className="form-control"
                    placeholder=""
                    type="text"
                    value={this.state.groupPrice}
                    onChange={this.onChange('groupPrice')}
                  />
                </div>
                <p className="help-block">
                  <FormattedMessage id="form.field.group.price.help" />
                </p>
              </div>
            </div>
          ) : (
            ''
          )}
          <div className="col-12">
            <div className="form-group m-b-2">
              <div className="checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={this.state.showUnitPrice}
                    onChange={() => this.setState({ showUnitPrice: !this.state.showUnitPrice })}
                  />{' '}
                  <FormattedMessage id={'form.field.price.add.unit.price'} />
                </label>
              </div>
            </div>
          </div>
          {this.state.showUnitPrice ? (
            <>
              <div className="col-12 col-sm-6">
                <div className="form-group field field-string">
                  <label className="control-label">
                    <FormattedMessage id={'form.field.wholesale.unit.price.label'} />
                  </label>
                  <div className="m-b-1">
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={this.state.wholesaleUnitPrice}
                      onChange={this.onWholesaleUnitPriceChange}
                    />
                  </div>
                  <p className="help-block">
                    <FormattedMessage id={'form.field.wholesale.unit.price.help'} />
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="form-group field field-string">
                  <label className="control-label">
                    <FormattedMessage id={'form.field.unit.price.label'} />
                  </label>
                  <div className="m-b-1">
                    <input
                      disabled={true}
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={this.state.unitPrice}
                      onChange={this.onChange('unitPrice')}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group field field-string">
                  <label className="control-label">
                    <FormattedMessage id={'form.field.preferred.price.display.label'} />
                  </label>

                  <div className="m-b-1">
                    <Select
                      name="form-field-delivery-day"
                      placeholder="Select..."
                      value={selectedPreferredPriceDisplayValue}
                      options={preferredPriceDisplayOptions}
                      onChange={(day) => this.onPreferredPriceDisplayChange(day.value)}
                    />
                  </div>
                  <p className="help-block">
                    <FormattedMessage id={'form.field.preferred.price.display.help'} />
                  </p>
                </div>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
}

export default injectIntl(PriceFields);
